export default [
  {
    path: '/content',
    name: 'content',
    component: () => import('@/views/content/ContentOverview.vue'),
    meta: {
      pageTitle: 'Content',
      breadcrumb: [
        {
          text: 'Content',
          active: true,
        },
      ],
    },
  },
]
